import { useEffect, useCallback, useRef, useState } from "react";
import { useMounted, useIdcTokenVerifyEndPointLazyQuery } from "@/hooks";
import routes from "@/lib/routes";
export function useRequireIdcLogin() {
  const {
    0: result,
    1: setResult
  } = useState(false);
  const {
    0: lazyloaded,
    1: setLazyLoaded
  } = useState(false);
  const timerRef = useRef(null);
  const mounted = useMounted();
  const [idcTokenVerify, {
    data,
    loading
  }] = useIdcTokenVerifyEndPointLazyQuery({
    onCompleted: () => {
      setLazyLoaded(true);
    },
    onError: () => {
      window.location.replace(routes.login);
    },
    fetchPolicy: "no-cache"
  });
  useEffect(() => {
    if (mounted) {
      idcTokenVerify();
    }
  }, [mounted]);
  useEffect(() => {
    if (mounted && !loading && lazyloaded) {
      if (!data) {
        window.location.replace(routes.login);
      } else {
        setResult(true);
      }
    }
  }, [mounted, loading, data, lazyloaded]);
  return result;
}